import { createContext, useState } from "react";
import { User, UserV2 } from '../../models/user/userModel'
import * as React from 'react';
// Valores por defecto
const userDefault = new User();

type UserContextType = {
    user: UserV2;
    setUser: (user: UserV2) => void;
};

// Creación de Context para guardar datos del usuario
export const UserContext = createContext<User>(userDefault);

export const UserContextV2 = createContext<UserContextType>(undefined);

export const UserProviderV2 = ({ children }) => {
    const [user, setUser] = useState(new UserV2());

    return (
        <UserContextV2.Provider value={{ user, setUser }}>
            {children}
        </UserContextV2.Provider>
    );
};
// Creación de Context login para control si esta o no logado
export const LoginContext = createContext(null);
